export enum EnvironmentFlag {
  Pwa = 'pwa',
  GetReservationDetailsSoldout = 'getresdetailssoldout',
  RoomexPaySalesforceIntegration = 'roomexpaysalesforceintegration',
  MultiroomFilter = 'multiroomfilter',
  ShowEVParkingFilter = 'showevparkingfilter'
}
